module.exports = __webpack_public_path__ + "fonts/iconfont.d897a77d.woff";